module.exports = __webpack_public_path__ + "Avidia - RMR HSA Welcome Kit.pdf";